import { render, staticRenderFns } from "./GatedEventPage.vue?vue&type=template&id=54660048&scoped=true&"
import script from "./GatedEventPage.vue?vue&type=script&lang=js&"
export * from "./GatedEventPage.vue?vue&type=script&lang=js&"
import style0 from "./GatedEventPage.vue?vue&type=style&index=0&id=54660048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54660048",
  null
  
)

export default component.exports